import { render, staticRenderFns } from "./notification-list.vue?vue&type=template&id=fd44b04c&scoped=true"
import script from "./notification-list.vue?vue&type=script&lang=js"
export * from "./notification-list.vue?vue&type=script&lang=js"
import style0 from "./notification-list.vue?vue&type=style&index=0&id=fd44b04c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd44b04c",
  null
  
)

export default component.exports